
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  projectSelectExistingProjectText: {
    id: "ProjectSelectExistingProject.text",
    defaultMessage: "Select existing Object",
  },
  projectSelectCreateProjectText: {
    id: "ProjectSelectCreateProject.text",
    defaultMessage: "No existing Object yet, please create one",
  },
  projectSelectButton: {
    id: "ProjectSelectButton.button",
    defaultMessage: "Accept",
  },
  projectSelectWithout: {
    id: "ProjectSelectWithout.without",
    defaultMessage: "I´d like to proceed without an object",
  },
  projectSelectButtonTitle: {
    id: "ProjectSelectButtonTitle.title",
    defaultMessage: "Edit Object",
  },
});

export default MESSAGES;